module.exports = __webpack_public_path__ + "static/GetStarted-2-3d46e36ee7fb70e5e501644242ddb03d.jpg";